import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import 'animate.css';
import VueI18n from 'vue-i18n'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import dotenv from 'dotenv'
dotenv.config({ path: `.env.${process.env.NODE_ENV}` })
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import 'vue-inner-image-zoom/lib/vue-inner-image-zoom.css';


import vWow from 'v-wow'




window.$ = window.jQuery = require('jquery')
import './assets/css/style.css'
import './assets/css/print.css'

Vue.use(VueToast);
Vue.use(VueSweetalert2);
Vue.use(DateRangePicker);
Vue.use(VueI18n)
Vue.use(vWow)
Vue.component("date-range-picker",DateRangePicker)
Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')


